import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import api from "../../utils/Api";

export default function IncidenciasAdmin() {
  const { token, loading } = useContext(AuthContext);
  const [incidencias, setIncidencias] = useState([]);
  const [generalError, setGeneralError] = useState("");
  const [notification, setNotification] = useState("");
  const [filterEstado, setFilterEstado] = useState("pendiente"); // 👈 por defecto pendientes

  // 🔹 Función para parsear fecha_hora estilo MySQL
  const formatFechaHora = (fechaHoraStr) => {
    if (!fechaHoraStr) return "";
    // Reemplazar espacio por "T" para que Date lo entienda
    const safeDate = fechaHoraStr.replace(" ", "T");
    const dt = new Date(safeDate);
    return dt.toLocaleString("es-ES"); // ej: 16/09/2025 18:45:23
  };


  const loadIncidencias = async () => {
    if (!token) return;
    try {
      const res = await api.get("/incidencias", {
        headers: { Authorization: `Bearer ${token}` },
      });
      setIncidencias(res.data);
    } catch (err) {
      setGeneralError("Error al cargar las incidencias.");
    }
  };

  useEffect(() => {
    loadIncidencias();
  }, [token]);

  const handleCambiarEstado = async (id, nuevoEstado) => {
    if (!token) return;

    try {
      await api.put(
        `/incidencias/${id}`,
        { estado: nuevoEstado },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setNotification(`Estado cambiado a ${nuevoEstado}`);
      setTimeout(() => setNotification(""), 4000);
      loadIncidencias();
    } catch (err) {
      setGeneralError(
        err.response?.data?.error || "Error al cambiar el estado."
      );
    }
  };

  if (loading) return <p className="text-center mt-5">Cargando...</p>;

  const incidenciasFiltradas = filterEstado
    ? incidencias.filter((i) => i.estado === filterEstado)
    : incidencias;

  return (
    <div className="container-fluid">
      <h1 className="fs-3 fw-bold">Incidencias de empleados</h1>

      {notification && <div className="alert alert-success">{notification}</div>}
      {generalError && <div className="alert alert-danger">{generalError}</div>}

      {/* Filtro por estado */}
      <div className="mb-3 d-flex gap-2 align-items-center">
        <label className="fw-bold">Filtrar por estado:</label>
        <select
          className="form-select w-auto"
          value={filterEstado}
          onChange={(e) => setFilterEstado(e.target.value)}
        >
          <option value="">Todos</option>
          <option value="pendiente">Pendiente</option>
          <option value="resuelta">Resuelta</option>
          <option value="rechazada">Rechazada</option>
        </select>
      </div>

      {/* Lista de incidencias */}
      {incidenciasFiltradas.length > 0 ? (
        <div className="row g-3">
          {incidenciasFiltradas.map((i) => (
            <div key={i.id} className="col-12 col-md-6 col-lg-4">
              <div className="card shadow-sm p-3 rounded-4 h-100">
                <div className="d-flex justify-content-between mb-2">
                  <strong>{i.tipo.toUpperCase()}</strong>
                  <span
                    className={`badge ${
                      i.estado === "pendiente"
                        ? "bg-warning text-dark"
                        : i.estado === "resuelta"
                        ? "bg-success"
                        : "bg-danger"
                    }`}
                  >
                    {i.estado.toUpperCase()}
                  </span>
                </div>

                <p className="mb-1">
                  <strong>Empleado:</strong> {i.usuario.nombre}
                </p>
                <p className="mb-1">
                   <strong>Fecha:</strong> {formatFechaHora(i.fecha_hora)}
                </p>
                <p className="mb-1">
                  <strong>Comentario:</strong> {i.comentario}
                </p>

                {/* Botones de acción */}
                <div className="mt-2 d-flex gap-2 flex-wrap">
                  {i.estado !== "pendiente" && (
                    <button
                      className="btn btn-warning btn-sm"
                      onClick={() => handleCambiarEstado(i.id, "pendiente")}
                    >
                      Marcar pendiente
                    </button>
                  )}
                  {i.estado !== "resuelta" && (
                    <button
                      className="btn btn-success btn-sm"
                      onClick={() => handleCambiarEstado(i.id, "resuelta")}
                    >
                      Marcar resuelta
                    </button>
                  )}
                  {i.estado !== "rechazada" && (
                    <button
                      className="btn btn-danger btn-sm"
                      onClick={() => handleCambiarEstado(i.id, "rechazada")}
                    >
                      Marcar rechazada
                    </button>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <p className="text-center text-muted mt-4">No hay incidencias.</p>
      )}
    </div>
  );
}
